module.exports = __webpack_public_path__ + "img/marcas_aliadas.6f23cdbb.png";